
let rushingDictionary = {
    "playerName":"NAME", 
    "playerClass":"CLASS", 
    "position":"POS", 
    "actualDate":"DATE", 
    "academicSeason":"SEASON", 
    "teamName":"TEAM", 
    "opponentTeamName":"OPP", 
    "gameResult":"RES", 
    "total":"TOTAL"
}



const rushingColumns = [
    "playerName",
    "playerClass",
    "position",
    "actualDate",
    "academicSeason",
    "teamName",
    "opponentTeamName",
    "gameResult",
    "total",
] as const;

const newRushingColumns = [
    "PLAYER",
    "CLASS",
    "POS",
    "DATE",
    "SEASON",
    "TEAM",
    "OPP",
    "RES",
    "TOTAL",
]

export function filterAndReplaceColumnNames<T extends Record<string, any>>(
    arr: T[]
): Record<string, any>[] {
    return arr.map((obj, index) => {
        const filteredAndRenamedObj: Record<string, any> = {
            ID: index + 1, // added ID starting from 1
        };

        // filtering columns
        rushingColumns.forEach((key) => {
            if (key in obj) {
                //renaming
                const newKey = rushingDictionary[key as keyof typeof rushingDictionary];
                filteredAndRenamedObj[newKey] = obj[key];
            }
        });

        //adding 
        if (obj.stats && typeof obj.stats === "object") {
            Object.entries(obj.stats).forEach(([statKey, statValue]) => {
              filteredAndRenamedObj[statKey.toUpperCase()] = statValue; // Use uppercase for consistency
            });
          }

        return filteredAndRenamedObj;
    });
}


// export function filterCols<T extends Record<string, any>>(
//     arr: T[]
// ): Record<string, any>[] {
//     return arr.map((obj, index) => {
//         const filteredAndRenamedObj: Record<string, any> = {
//             ID: index + 1,
//         };

//         newRushingColumns.forEach((key) => {
//             if (key in obj) {
//                 filteredAndRenamedObj[key] = obj[key];
//             }
//         });

//         if (obj.stats && typeof obj.stats === "object") {
//             Object.entries(obj.stats).forEach(([statKey, statValue]) => {
//                 filteredAndRenamedObj[statKey.toUpperCase()] = statValue; // Use uppercase for consistency
//             });
//         }

//         return filteredAndRenamedObj;
//     });
// }

export function filterCols<T extends Record<string, any>>(
    arr: T[],
    options?: { useMetadataIdAsPlayerId?: boolean }
): Record<string, any>[] {
    const newRushingColumns = [
        "PLAYER", "CLASS", "POS", "DATE", "SEASON",
        "TEAM", "OPP", "RES", "PERIOD_TYPE", "DATA_SOURCE", "PERIOD_NUMBER", "TOTAL"
    ];

    return arr.map((obj, index) => {
        let filteredAndRenamedObj: Record<string, any> = { ID: index + 1 };

        let tempData: Record<string, any> = {};

        // Support data-source fields even when not nested in `metadata`
        const rawDataSource =
            (obj as any)?.data_source 
        if (rawDataSource !== undefined) {
            tempData["DATA_SOURCE"] = rawDataSource;
        }

        if (obj.metadata && typeof obj.metadata === "object") {
            Object.entries(obj.metadata).forEach(([statKey, statValue]) => {
                tempData[statKey.toUpperCase()] = statValue;
            });
        }

        if (obj.stats && typeof obj.stats === "object") {
            Object.entries(obj.stats).forEach(([statKey, statValue]) => {
                tempData[statKey.toUpperCase()] = statValue;
            });
        }

        // add columns in the defined order but only if they exist
        newRushingColumns.forEach((col) => {
            if (tempData[col] !== undefined) {
                filteredAndRenamedObj[col] = tempData[col];
            }
        });

        // appending any remaining extra columns at the end
        Object.entries(tempData).forEach(([key, value]) => {
            if (!(key in filteredAndRenamedObj)) {
                filteredAndRenamedObj[key] = value;
            }
        });

        // Career search: metadata.ID is the SQL result rank (ROW_NUMBER), not player_id.
        // metadata.PLAYER_ID is the school-specific id for player dashboard links.
        // Displayed table `ID` stays the page row index (index + 1).
        if (options?.useMetadataIdAsPlayerId) {
            const playerId = tempData.PLAYER_ID ?? tempData.ID;
            if (playerId !== undefined && playerId !== null && playerId !== "") {
                filteredAndRenamedObj.PLAYER_ID = playerId;
            }
        }

        // Preserve career-transfer fields for expand UI (not rendered as columns)
        if ((obj as any).has_transfers !== undefined) {
            filteredAndRenamedObj.has_transfers = (obj as any).has_transfers;
        }
        if (Array.isArray((obj as any).transfer_careers)) {
            filteredAndRenamedObj.transfer_careers = (obj as any).transfer_careers;
        }
        if ((obj as any).transfer_totals !== undefined) {
            filteredAndRenamedObj.transfer_totals = (obj as any).transfer_totals;
        }

        return filteredAndRenamedObj;
    });
}






